import { hasMany } from "vue-app-utils";
export default {
  hasMany
};
